// Availability Settings Page JavaScript
// Handles: timeslots, override entries (specific dates), DND, booking reminder,
// contact methods, timezone, and mentorship limit dropdown.

$(document).on("turbo:load", function () {
  if (!$("body").hasClass("availability")) return;

  var $intervalHash = $("data#time_interval").data("value");
  var $addTimeslotOptions = $("#add_timeslot_options");

  // Routes
  var Routes = {
    toggleDnd: "/main/toggle_dnd",
    toggleBookingReminder: "/main/toggle_booking_reminder",
    updateMentorContact: "/main/update_mentor_contact",
    updateTimezone: "/main/update_timezone",
    overrideEntry: "/main/override_entry",
  };

  // ---- Utility functions (inlined, no dependency on form_helpers) ----

  function checkEntryFieldsFilled() {
    var filled = true;
    $('[name*="entry["]:not([name="entry[note]"])').each(function () {
      if ($.trim($(this).val()) === "") {
        filled = false;
        return false; // break
      }
    });
    return filled;
  }

  function buildEntryParams() {
    var params = {};
    $('[name*="entry["]').each(function () {
      params[$(this).attr("name")] = $(this).val();
    });
    return params;
  }

  // ---- Datepickers ----

  if ($.fn.datepicker) {
    $("#entry_start_date, #entry_end_date").datepicker({
      dateFormat: "d M yy",
      changeMonth: true,
      changeYear: true,
    });
  }

  // ---- DND Toggle ----

  $(document).on("click", ".toggle_dnd", function () {
    var $toggle = $(this);
    $toggle.toggleClass("fa-toggle-on fa-toggle-off tw-text-green-600 tw-text-gray-400");

    $.ajax({
      method: "POST",
      url: Routes.toggleDnd,
      data: {
        do_not_disturb: $toggle.hasClass("fa-toggle-on"),
        admin_access: $("#admin_access").val(),
        mentor_id: $("#mentor_id").val(),
      },
      success: function (response) {
        $("#do_not_disturb_notice").toggle(response.status === true);
      },
      error: function () {
        $toggle.toggleClass("fa-toggle-on fa-toggle-off tw-text-green-600 tw-text-gray-400");
        popupAlert("Failed to update Do Not Disturb setting");
      },
    });
  });

  // ---- Booking Reminder Toggle ----

  $(document).on("click", ".toggle_booking_reminder", function () {
    var $toggle = $(this);
    $toggle.toggleClass("fa-toggle-on fa-toggle-off tw-text-green-600 tw-text-gray-400");

    $.ajax({
      method: "POST",
      url: Routes.toggleBookingReminder,
      data: {
        booking_reminder: $toggle.hasClass("fa-toggle-on"),
        admin_access: $("#admin_access").val(),
        mentor_id: $("#mentor_id").val(),
      },
      success: function (response) {
        popupNotification("Booking Reminder is " + response.status);
      },
      error: function () {
        $toggle.toggleClass("fa-toggle-on fa-toggle-off tw-text-green-600 tw-text-gray-400");
        popupAlert("Failed to update Booking Reminder setting");
      },
    });
  });

  // ---- Meetup Fields ----

  $(document).on("click", "#add_meetup_field", function () {
    var $template = $(".meetup_fields").first().clone();
    $template.find("#id, #title, #description, #location").val("");
    $template.find(".meetup_state").val("true");
    $template.find(".toggling").show();
    $template.find(".restore_meetup_field").hide();
    $template.insertAfter($(".meetup_fields").last());
  });

  $(document).on("click", ".remove_meetup_field", function () {
    var $parent = $(this).closest(".meetup_fields");
    $parent.find(".meetup_state").val("false");
    $parent.find(".restore_meetup_field").show();
    $parent.find(".toggling").fadeOut();
  });

  $(document).on("click", ".restore_meetup_field", function () {
    var $parent = $(this).closest(".meetup_fields");
    $parent.find(".meetup_state").val("true");
    $parent.find(".restore_meetup_field").hide();
    $parent.find(".toggling").fadeIn();
  });

  $(document).on("click", "#update_contact_methods", function () {
    var mentorContactParams = {};
    var meetupContactParams = {};
    var meetupIndex = 0;

    $(".mentor_contact_field").each(function () {
      var $field = $(this);
      var value = $field.attr("type") === "checkbox" ? $field.is(":checked") : $field.val();
      mentorContactParams[$field.attr("name")] = value;
    });

    var currentMeetup = {};
    var fieldCount = 0;

    $(".contact_meetup_field").each(function () {
      var $field = $(this);
      currentMeetup[$field.attr("name")] = $field.val();
      fieldCount++;

      if (fieldCount % 5 === 0) {
        meetupContactParams[meetupIndex] = currentMeetup;
        currentMeetup = {};
        meetupIndex++;
      }
    });

    $.ajax({
      method: "POST",
      url: Routes.updateMentorContact,
      data: {
        user_mentor_contact: mentorContactParams,
        meetup_contact: meetupContactParams,
        admin_access: $("#admin_access").val(),
        mentor_id: $("#mentor_id").val(),
      },
      success: function (response) {
        if (response.boolean && !response.preference) {
          popupAlert("Please select at least 1 preference");
        } else if (response.boolean) {
          popupNotification("Saved");
          $.each(response.update_id, function (_, value) {
            var idx = Object.keys(value)[0];
            $(".meetup_fields").eq(parseInt(idx)).find("#id").val(value[idx]);
          });
        } else {
          popupAlert("An error has occurred");
        }
      },
      error: function () {
        popupAlert("Failed to update contact methods");
      },
    });
  });

  // ---- Timeslot Management ----

  $(document).on("click", "#add_timeslot", function (e) {
    e.preventDefault();
    $addTimeslotOptions.slideToggle(200);
  });

  $(document).on("click", "#add_selected_time, .time_value .removing_times", function (e) {
    e.preventDefault();
    e.stopPropagation();

    var $this = $(this);
    var isRemoving = $this.hasClass("removing_times");
    var day, start, end;

    if (isRemoving) {
      var $timeValue = $this.closest(".time_value");
      day = $timeValue.data("day");
      start = $timeValue.data("start");
      end = $timeValue.data("end");
    } else {
      day = $("#selected_day").val();
      start = $("#start_time").val();
      end = $("#end_time").val();

      var intervals = $intervalHash || $("data#time_interval").data("value");
      var startIndex = intervals.indexOf(start);
      var endIndex = intervals.indexOf(end);
      endIndex = endIndex === 0 ? 48 : endIndex;

      if (endIndex <= startIndex) {
        popupAlert("Start time must be earlier than end time");
        return;
      }
    }

    var $form = $("#update_timeslots_hidden").closest("form");
    var updateUrl = $form.attr("action");

    if (!updateUrl) {
      popupAlert("Unable to find update URL");
      return;
    }

    showFlLoader();

    $.ajax({
      method: "PATCH",
      url: updateUrl,
      data: {
        removing: isRemoving,
        day: day,
        start: start,
        end: end,
        admin_access: $("#admin_access").val(),
        mentor_id: $("#mentor_id").val(),
      },
      success: function (response) {
        if (response.error) {
          popupAlert(response.error);
        } else {
          var $response = $(response);
          var responseDay = $response.data("day");
          $('.timeslot_container[data-day="' + responseDay + '"]').html($response.html());
        }
        hideFlLoader();
      },
      error: function (xhr) {
        var errorMsg = xhr.responseJSON && xhr.responseJSON.error
          ? xhr.responseJSON.error
          : "Failed to update timeslot";
        popupAlert(errorMsg);
        hideFlLoader();
      },
    });
  });

  // ---- Override Entries (Set Up Specific Dates) ----

  $(document).on("click", "#add_this_entry, .override_delete", function (e) {
    e.preventDefault();

    var $this = $(this);
    var isDelete = $this.hasClass("override_delete");
    var overrideUrl = $this.data("url") || Routes.overrideEntry;

    // Validate required fields for new entries
    if (!isDelete && !checkEntryFieldsFilled()) {
      popupAlert("Please fill in the dates");
      return;
    }

    var parameters = isDelete
      ? { delete: true, id: $this.data("id") }
      : buildEntryParams();

    showFlLoader();

    $.ajax({
      method: "POST",
      url: overrideUrl,
      data: {
        parameters: parameters,
        admin_access: $("#admin_access").val(),
        mentor_id: $("#mentor_id").val(),
      },
      success: function (response) {
        if (response.error) {
          popupAlert(response.error);
        } else {
          $("#override_entries").html($(response).html());
          if (!isDelete) {
            $('[name="entry[note]"]').val("");
          }
        }
        hideFlLoader();
      },
      error: function () {
        popupAlert("Failed to update override entry");
        hideFlLoader();
      },
    });
  });

  // Past entries toggle
  $(document).on("click", "#show_past_entries", function () {
    $('.override_entry_items[data-previous="true"]').fadeToggle();
  });

  // ---- Timezone Update ----

  $(document).on("change", "#timeslot_timezone", function () {
    var timezone = $(this).val();

    $.ajax({
      method: "POST",
      url: Routes.updateTimezone,
      data: {
        timezone: timezone,
        mentor_id: $("#mentor_id").val(),
      },
      success: function (response) {
        popupNotification("Timezone updated to " + response.timezone);
      },
      error: function () {
        popupAlert("Failed to update timezone");
      },
    });
  });

  // ---- Start Time Sync ----

  $(document).on("change", "#start_time", function () {
    var intervals = $intervalHash || $("data#time_interval").data("value");
    var selectedIndex = intervals.indexOf($(this).val());
    var $endTime = $("#end_time");
    var $optionsSource = $("#end_time_options option");

    $endTime.empty();
    $optionsSource.slice(selectedIndex).each(function () {
      $endTime.append($(this).clone());
    });
  });

  // ---- Mentoring Limit Save ----

  $(document).on("click", "#save_mentoring_limit", function (e) {
    e.preventDefault();

    var $btn = $(this);
    var url = $btn.data("url");
    var method = $btn.data("method");
    var limitVal = $("#mentoring_limit_input").val();
    var programId = $btn.data("program-id");

    if (limitVal === "" || parseInt(limitVal) < 0) {
      popupAlert("Please enter a valid number (0 for unlimited)");
      return;
    }

    $.ajax({
      method: method,
      url: url,
      dataType: "json",
      data: {
        user_mentoring_limit: {
          limit: limitVal,
          program_id: programId || "",
        },
      },
      success: function (response) {
        if (response.success) {
          var display = parseInt(response.limit) === 0 ? "Unlimited" : response.limit;
          $("#mentoring_limit_display").text(display);
          popupNotification("Mentee limit saved");
        } else {
          popupAlert("Failed to save mentee limit");
        }
      },
      error: function () {
        popupAlert("Failed to save mentee limit");
      },
    });
  });
});
